module.exports = __webpack_public_path__ + "static/img/home07.489de32d.png";